import { GetterTree } from "vuex";
import { RootState, CompanyAdminzoneState } from "@/types/store/adminzone";

export const getters: GetterTree<CompanyAdminzoneState, RootState> = {
  //@ts-ignore
  GET_COMPANIES: (state): Array<CompanyAdminzoneState> => state.companies
}
